import { SITES } from '../gen/lang.js';

const getCookie = (key) => {
    const b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
    return b ? b.pop() : '';
};
const findSiteFromUrl = () => {
    const domainRegex = /[\w-]+\.?\w{2}?\.\w{2,3}$/;
    const currentCountry = window.location.hostname.match(domainRegex);
    return SITES.find((site) => site.domain === currentCountry?.[0]);
};
const findLocaleFromUrlAndCookie = () => {
    const site = findSiteFromUrl();
    if (!site) {
        return 'de-DE';
    }
    // we get locale from cookie only for sites that have more than one defined locale
    if (site.alternateLocales.length) {
        const split = window.location?.pathname?.split('/') || [];
        const urlLanguage = split[1];
        const language = site.language === urlLanguage
            ? site.locale
            : site.alternateLocales.find((alt) => alt.language === urlLanguage)?.locale;
        if (language) {
            return language;
        }
        console.log(document.cookie);
        const cookieLanguage = getCookie('_zpLanguage');
        if (cookieLanguage) {
            return site.language === cookieLanguage
                ? site.locale
                : site.alternateLocales.find((alt) => alt.language === cookieLanguage)?.locale;
        }
    }
    return site.locale;
};

export { findLocaleFromUrlAndCookie, findSiteFromUrl, getCookie };
//# sourceMappingURL=cookieService.js.map
